import {
  EmojiFaceWithSmileleIcon,
  HustlerIcon,
  LeaderIcon,
  MasterIcon,
  NewbieIcon,
} from '@sketchnote/icons';

export const AchievementLevels = {
  newbie: NewbieIcon,
  hustler: HustlerIcon,
  leader: LeaderIcon,
  master: MasterIcon,
  faceSmile: EmojiFaceWithSmileleIcon,
};

export const AchievementTypes = {
  PROGRESS: 'progress',
  STREAKS: 'streaks',
  ACHIEVEMENTS: 'achievements',
  EXPERIENCE_POINTS_DETAILED: 'experiencePointsDetailed',
  KNOW_MORE_ACTION: 'knowMoreAction',
};

export const achievementsData = [
  {
    type: 'progress',
    title: 'General progress',
    progress: { currentPoints: 10, targetPoints: 400, targetLevel: 'Newbie' },
    levelAchieved: {
      levels: [
        { name: 'Newbie', isLocked: false, iconName: 'newbie' },
        { name: 'Hustler', isLocked: true, iconName: 'hustler' },
        { name: 'Leader', isLocked: true, iconName: 'leader' },
        { name: 'Master', isLocked: true, iconName: 'master' },
      ],
      title: 'Levels achieved',
    },
  },
  {
    type: 'streaks',
    title: 'Streaks',
    description:
      'Earn 10xP for every day you learn a lesson or work on a creation with  Sketchnote.',
    streaksItem: [
      { day: 1, points: 10, isUnlocked: true },
      { day: 2, points: 20, isUnlocked: false },
      { day: 3, points: 30, isUnlocked: false },
      { day: 4, points: 40, isUnlocked: false },
      { day: 5, points: 50, isUnlocked: false },
      { day: 6, points: 60, isUnlocked: false },
    ],
    streakDay: 3,
  },
  {
    type: 'achievements',
    title: 'Achievements',
    description: 'Earn more points and keep learning with Sketchnote to collect achievements.',
    latestAchievements: {
      title: 'Your latest achievements',
      description: 'View your last four achievements',
      timeline: [
        {
          count: 3,
          timestamp: 'Wed, Jun 4',
          type: 'lesson',
        },
        {
          count: 3,
          timestamp: 'Wed, Jun 4',
          type: 'lesson',
        },
        {
          count: 3,
          timestamp: 'Wed, Jun 4',
          type: 'lesson',
        },
        {
          count: 3,
          timestamp: 'Wed, Jun 4',
          type: 'lesson',
        },
      ],
    },
  },
  {
    type: 'experiencePointsDetailed',
    title: 'How do I earn experience points',
    actionPoints: [
      'Complete reading each card.',
      'Answer the MCQ questions correctly in the active learning part of the learn module',
      'Complete tasks in the create module.',
    ],
    image: 'https://via.placeholder.com/150',
  },
  {
    type: 'knowMoreAction',
    title: 'Need to know more?',
    description: 'We are here to help you!',
    actionBtnTxt: 'Visit help center',
  },
];

export const displayMessage = ({ type, count }) => {
  if (type === 'lessons') {
    if (count === 1) return `${count} lesson mastered`;
    else return `${count} lessons mastered`;
  }
  if (type === 'quizzes') {
    if (count === 1) return `${count} quiz aced`;
    else return `${count} quizzes aced`;
  }
  if (type === 'microtasks') {
    if (count === 1) return `${count} task completed`;
    else return `${count} tasks completed`;
  }
  if (type === 'modules') {
    if (count === 1) return `${count} module wrapped up`;
    else return `${count} modules wrapped up`;
  }
  return '';
};
